module.exports = __webpack_public_path__ + "img/scene2.da11adc6.png";